import styled, { css } from 'styled-components';

export const StyledWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  border: 1px solid ${({ theme }) => theme.colors.lightGrey};
  border-radius: 5px;
  height: 44px;
  transition: border 0.3s;
  ${({ noBorder }) => noBorder && css`
    border: 0;
  `};
`;

export const StyledInputWrapper = styled.div`
  height: 100%;
`;

export const StyledInput = styled.input`
  ${({ theme }) => theme.fonts.mulishLight};
  font-size: 14px;
  line-height: 1;
  letter-spacing: -0.025em;
  color: ${({ theme, color }) => color ? color : theme.colors.darkGrey};
  border: 0;
  outline: 0;
  padding: 10px 15px;
  border-radius: 5px;
  height: 100%;
  ${({ paddingRight }) => paddingRight && css`
      padding-left: 0;
      padding-right: 15px;
  `};
  ${({ paddingLeft }) => paddingLeft && css`
      padding-left: 15px;
      padding-right: 0;
  `};
  ::placeholder {
    color: ${({ theme }) => theme.colors.mediumGrey};
  };
`;

export const StyledContainer = styled.div`
  display: inline-flex;
  flex-direction: column;
  margin-bottom: 20px;
  max-width: ${({ maxWidth }) => maxWidth};
  ${({ disabled }) => disabled && css`
    pointer-events: none;
    opacity: 0.5;
  `};
  ${({ readonly }) => readonly && css`
    pointer-events: none;
    opacity: 0.7;
  `};
  ${({ error }) => error && css`
    ${StyledWrapper} {
      border: 1px solid ${({ theme }) => theme.colors.error};
    };
  `};
  ${({ fullWidth }) => fullWidth && css`
    width: 100%;
    ${StyledInputWrapper} {
      width: 100%;
    };
    ${StyledInput} {
      width: 100%;
    };
  `};
  ${({ customStyle }) => customStyle && customStyle};
`;